export default __webpack_public_path__ + "static/media/n6.3fa67ea6.png";